import validate from "/home/runner/_work/shadow/shadow/node_modules/.pnpm/nuxt@3.21.2_@parcel+watcher@2.5.1_@types+node@24.10.8_@vue+compiler-sfc@3.5.30_cac@6.7._51d4fb18d44cb178e5b652eca0d179c0/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/home/runner/_work/shadow/shadow/node_modules/.pnpm/nuxt@3.21.2_@parcel+watcher@2.5.1_@types+node@24.10.8_@vue+compiler-sfc@3.5.30_cac@6.7._51d4fb18d44cb178e5b652eca0d179c0/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}